'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _invariant = require('react-utils/invariant');

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var segmentize = function segmentize(uri) {
  return uri.replace(/(^\/+|\/+$)/g, '').split('/');
};

var paramRe = /^:(.+)/;

exports.default = function (routes) {
  var routeSegmentsCache = {};

  routes.forEach(function (route) {
    routeSegmentsCache[route] = segmentize(route);
  });

  return function (route, pathname) {
    var pathnameSegments = segmentize(pathname);
    var routeSegments = routeSegmentsCache[route];

    (0, _invariant2.default)(routeSegments, 'unexpected route ' + route);

    if (pathnameSegments.length !== routeSegments.length) {
      return false;
    }

    var index = 0;
    for (; index < routeSegments.length; index++) {
      var routeSegment = routeSegments[index];
      var pathnameSegment = pathnameSegments[index];

      if (routeSegment !== pathnameSegment && !routeSegment.match(paramRe)) {
        return false;
      }
    }

    return true;
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react-rhumb/static-1.2431/js/internal/matchRoute.js
// module id = 634
// module chunks = 3 4